import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';

@Injectable({ providedIn: 'root' })
export class DashboardDefaultGuard {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<UrlTree> {
    return this.authenticationService.getPlanFeaturesEnabled().pipe(
      map(plan => {
        const logistics = plan?.default_skin === 'logistics' &&
          Array.isArray(plan?.available_dashboard_skins) &&
          plan.available_dashboard_skins.includes('logistics');
        return this.router.createUrlTree(
          [logistics ? '/dashboard/logistics' : '/dashboard'],
          { queryParams: route.queryParams }
        );
      }),
      catchError(() => of(this.router.createUrlTree(['/dashboard'], { queryParams: route.queryParams })))
    );
  }
}
